import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './index.module.scss';
import { Button, Tree, Table, Drawer, Form, Input, Radio, Select, message, Popconfirm } from 'antd';
import { create, detail, list, paramList, update } from '@/api/track/track';
import { getTableScroll, state } from '@/store/index';
import { useSnapshot } from 'valtio';

const TrackConfig = () => {
  const [editPointId, setEditPointId] = useState<string>('');
  const [data, setData] = useState([] as any);
  const [open, setOpen] = useState(false);
  const [drawerType, setDrawerType] = useState(1);
  const [form] = Form.useForm();
  const [drawData, setDrawData] = useState([] as any);
  const [scrollY, setScrollY] = useState('');
  const [page, setPage] = useState({ pageSize: 10, pageNum: 1, total: 0 });
  const [paramOptions, setParamOptions] = useState([] as any);
  const { currentShopPlatformType, currentShopId } = useSnapshot(state);
  const [paramCodeOptions, setParamCodeOptions] = useState([] as any);
  const drawColumns = [
    {
      title: '参数编码',
      key: 'paramCode',
      dataIndex: 'paramCode',
      // render: (_: any, record: any) => (
      //   <>
      //     <Input placeholder='请输入参数编码' value={_}></Input>
      //   </>
      // ),
    },
    {
      title: '参数名称',
      key: 'paramName',
      dataIndex: 'paramName',
      width: 150,
      render: (_: any, record: any, index: number) => (
        <>
          <Select
            fieldNames={{ label: 'paramName', value: 'paramCode' }}
            options={paramOptions}
            style={{ width: 150 }}
            value={_}
            placeholder="请选择参数"
            onChange={e => {
              selectDrawTable(e, index);
            }}></Select>
        </>
      ),
    },
    {
      dataIndex: 'description',
      title: '参数描述',
      key: 'description',
      // render: (_: any, record: any) => (
      //   <>
      //     <Input placeholder='请输入参数描述' value={_}></Input>
      //   </>
      // ),
    },
    {
      title: '操作',
      key: 'action',
      render: (_: any, record: any, index: number) => (
        <>
          <Popconfirm
            title="确认删除此参数"
            onConfirm={() => {
              confirmDelete(index);
            }}>
            <Button type="link">删除</Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  const confirmDelete = (index: number) => {
    const arr = [...paramOptions];
    arr.forEach((item: any) => {
      if (item.paramCode === drawData[index].paramCode) {
        item.disabled = false;
      }
    });
    setParamOptions(arr);
    //删除drawdata对应下标对象
    setDrawData((prevData: any) => {
      const newData = [...prevData];
      newData.splice(index, 1); // 从index位置删除1个元素
      return newData;
    });
  };

  const selectDrawTable = (e: any, index: number) => {
    const obj = paramOptions.filter((item: any) => {
      return item.paramCode === e;
    })[0];
    let n = [...drawData];
    n[index] = obj;
    setDrawData(n);

    const arr = [...paramOptions];
    // arr.forEach((item: any) => {
    //   if (item.paramCode === e) {
    //     item.disabled = true
    //   }
    // })
    arr.map((item: any) => {
      const t = n.filter((itm: any) => {
        return itm.paramCode === item.paramCode;
      });
      if (t.length > 0) {
        item.disabled = true;
      } else {
        item.disabled = false;
      }
    });
    setParamOptions(arr);
  };

  const treeData: any[] = [
    {
      title: '店铺活动',
      key: '1',
      children: [
        {
          title: '宠物建档有礼',
          key: '1-1',
        },
      ],
    },
  ];

  const onSelect = () => {};

  const columns = [
    {
      title: '所属ID',
      dataIndex: 'pointId',
      key: 'pointId',
    },
    {
      title: '埋点编码',
      dataIndex: 'pointCode',
      key: 'pointCode',
    },
    {
      title: '埋点名称',
      dataIndex: 'pointName',
      key: 'pointName',
    },
    {
      title: '埋点参数',
      dataIndex: 'paramStr',
      key: 'paramStr',
    },
    {
      title: '埋点状态',
      dataIndex: 'statusName',
      key: 'statusName',
      width: '100px',
    },
    {
      title: '操作',
      key: 'action',
      width: '80px',
      render: (_: any, record: any) => (
        <>
          <Button
            size="small"
            type="link"
            onClick={() => {
              getDetail(record, 3);
            }}>
            编辑
          </Button>
        </>
      ),
    },
  ];

  const getParam = async (parentId: any, n?: any) => {
    const res = await paramList(parentId);
    let arr: any = res.rows;
    if (n) {
      arr.map((item: any) => {
        const t = n.filter((itm: any) => {
          return itm.paramCode === item.paramCode;
        });
        if (t.length > 0) {
          item.disabled = true;
        }
      });
    }
    if (parentId === 0) {
      setParamCodeOptions(arr);
    } else {
      setParamOptions(arr);
    }

    return arr;
    // setDrawData(res.rows)
  };

  const getDetail = async (record: any, dt: number) => {
    setDrawerType(dt);
    const res: any = await detail({ pointId: record.pointId });
    const { data } = res;

    // 设置新的编辑器内容
    setEditPointId(record.pointId);
    form.setFieldsValue({
      pointId: record.pointId,
      pointCode: data.pointCode,
      pointName: data.pointName,
      description: data.description,
      status: data.status,
      hasParams: data.hasParams,
    });
    setDrawData(data.params);

    const codeOptions = await getParam(0);
    console.log(codeOptions);
    await getParam(
      codeOptions.filter((item: any) => {
        return item.paramCode === data.pointCode;
      })[0].id,
      data.params,
    );

    setOpen(true);
  };

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const onFinish = async (values: any) => {
    console.log('Success:', values);
    let param: any = {
      pointCode: values.pointCode,
      pointName: values.pointName,
      status: values.status,
      description: values.description,
      hasParams: values.hasParams,
      shopId: currentShopId,
      activityType: 'pet_profile',
    };

    if (param.hasParams === 1) {
      console.log(drawData.length === 0);
      const arr = drawData.filter((item: any) => {
        return item.paramCode !== '';
      });
      if (arr.length === 0) {
        message.error('至少添加一个参数');
        return;
      }
      param.params = arr;
    }
    if (drawerType === 1) {
      const res = await create(param);
      if (res) {
        message.success('添加成功');
        setOpen(false);
        getList();
      }
    } else {
      param.pointId = editPointId;
      const res = await update(param);
      if (res) {
        message.success('编辑成功');
        setOpen(false);
        getList();
      }
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
    message.error(errorInfo.errorFields[0].errors[0]);
  };

  const getList = async () => {
    const res = await list({ pageNum: page.pageNum, pageSize: page.pageSize, shopId: currentShopId });
    let arr: any = res.rows;

    arr.forEach((item: any) => {
      item.paramStr = JSON.parse(item.paramsJson)
        .map((i: any) => i.label)
        .join(',');
    });
    setData(res.rows);
    setPage({
      ...page,
      total: res.total,
    });
    setScrollY(getTableScroll());
  };

  useEffect(() => {
    getList();
    // setScrollY(getTableScroll());
  }, [page.pageSize, page.pageNum]);

  const addParam = () => {
    setDrawData([
      ...drawData,
      {
        paramCode: '',
        paramName: null,
        description: '',
      },
    ]);
  };

  const addTrack = () => {
    getParam(0);
    setDrawerType(1);
    setOpen(true);
    setDrawData([]);
    form.resetFields();
  };

  // useEffect(() => {

  // }, [open])

  return (
    <div style={{ padding: '32px 0 0 32px', height: '100%' }}>
      <div style={{ fontSize: 18, fontWeight: 'bold', color: '#000000', height: 50 }}>埋点配置</div>
      <div style={{ height: 'calc(100% - 50px)', display: 'flex', flexDirection: 'row' }}>
        <div className={styles['leftContainer']}>
          <Tree
            defaultSelectedKeys={['1-1']}
            defaultExpandAll
            onSelect={onSelect}
            treeData={treeData}
          />
        </div>
        <div className={styles['right-container']}>
          <div className={styles['buttons']}>
            <Button
              onClick={() => {
                addTrack();
              }}
              className={styles['addButton']}
              type="primary">
              新建埋点
            </Button>
          </div>
          <Table
            style={{ marginLeft: 32, marginRight: 32, width: 'calc(100% - 64px)' }}
            columns={columns}
            dataSource={data}
            pagination={{
              pageSize: page.pageSize,
              current: page.pageNum,
              total: page.total,
              onChange: (pageNum, pageSize) => {
                setPage({ ...page, pageNum, pageSize });
              },
            }}
            scroll={{ y: scrollY }}
          />
        </div>
      </div>

      <Drawer
        title={`${drawerType === 1 ? '新建' : '编辑'}-埋点`}
        size="large"
        placement="right"
        onClose={onClose}
        open={open}
        extra={
          <div>
            <Button
              type="primary"
              onClick={() => {
                form.submit();
              }}>
              保存
            </Button>
          </div>
        }>
        <Form
          name="basic"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          style={{ marginTop: '24px' }}
          form={form}
          initialValues={{
            affiliation: '店铺活动/宠物建档有礼',
          }}>
          <Form.Item
            label="所属埋点"
            name="affiliation"
            rules={[{ required: true }]}>
            <Input disabled />
          </Form.Item>
          <Form.Item
            label="埋点编码"
            name="pointCode"
            rules={[{ required: true }]}>
            {/* <Input placeholder='请输入埋点编码' maxLength={50} /> */}
            <Select
              fieldNames={{ label: 'paramName', value: 'paramCode' }}
              options={paramCodeOptions}
              placeholder="请选择埋点编码"
              onChange={e => {
                setDrawData([]);
                getParam(
                  paramCodeOptions.filter((item: any) => {
                    return item.paramCode == e;
                  })[0].id,
                );
              }}></Select>
          </Form.Item>
          <Form.Item
            label="埋点名称"
            name="pointName"
            rules={[{ required: true }]}>
            <Input
              placeholder="请输入埋点名称"
              maxLength={50}
            />
          </Form.Item>
          <Form.Item
            label="埋点状态"
            name="status"
            rules={[{ required: true }]}>
            <Radio.Group>
              <Radio value={'not_effective'}>未生效</Radio>
              <Radio value={'effective'}>生效中</Radio>
              <Radio value={'disabled'}>已停用</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            label="埋点简介"
            name="description"
            rules={[{ required: true }]}>
            <Input
              placeholder="请输入埋点简介"
              maxLength={50}
            />
          </Form.Item>
          <Form.Item
            label="是否有参数"
            name="hasParams"
            rules={[{ required: true }]}>
            <Radio.Group>
              <Radio value={0}>无</Radio>
              <Radio value={1}>有</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item label="参数配置">
            <div style={{ float: 'right', display: 'flex', flexDirection: 'row', alignItems: 'flex-end' }}>
              <Button
                type="primary"
                size="small"
                disabled={drawData.length === 5}
                onClick={addParam}>
                添加参数
              </Button>
              <div style={{ fontSize: 12, marginLeft: 16 }}>最多支持5个参数</div>
            </div>
          </Form.Item>
        </Form>
        <Table
          columns={drawColumns}
          dataSource={drawData}
          pagination={false}></Table>
      </Drawer>
    </div>
  );
};
export default TrackConfig;
